import { render, staticRenderFns } from "./vcMail.vue?vue&type=template&id=c03a8c82&"
import script from "./vcMail.vue?vue&type=script&lang=js&"
export * from "./vcMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports